module.exports = __webpack_public_path__ + "img/gebratenesschweinefleischseitlich.7bb29e08.jpg";